import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import {
  AdvancedCardSearch,
  FullProps,
} from '@sorare/marketplace/src/searchCards/AdvancedCardSearch';

export const FootballCardSearch = (props: Omit<FullProps, 'sport'>) => {
  return <AdvancedCardSearch sport={Sport.FOOTBALL} {...props} />;
};
